/* eslint import/first: 0 */
import '../configs/jquery.conf';
import 'bootstrap';
import 'select2';
/* eslint import/first: 2 */

import '../signout';
import '../disable_button_on_submit';


$(() => {
  $('.container-fluid.main').addClass('loaded');
});
